<template>
  <BigCardCarousel
    :top-title="mgnlPropsWithBtnColors.topTitle"
    :top-title-color="mgnlPropsWithBtnColors.topTitleColor"
    :subtitle="mgnlPropsWithBtnColors.subtitle"
    :subtitle-color="mgnlPropsWithBtnColors.subtitleColor"
    :items="mgnlPropsWithBtnColors.items"
    :products-ids="(mgnlPropsWithBtnColors.productsIds as string[])"
    :data-ab-id="mgnlProps?.dataABId"
    :enable-legal-disclaimer="mgnlProps?.enableLegalDisclaimer"
    :legal-text="mgnlProps?.legalText"
    :legal-title="mgnlProps?.legalTitle"
    :title-or-subtitle="mgnlProps?.titleOrSubtitle"
  />
</template>

<script lang="ts" setup>
import BigCardCarousel from '~/components/Shared/BigCardCarousel/BigCardCarousel.vue';
import { BigCardCarouselBuilder, WrapperProps } from '~/components/Shared/BigCardCarousel/BigCardCarousel.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);
const { topTitleColor, subtitleColor, imageLoadType } = toRefs(props);
provide('imageLoadType', imageLoadType?.value);

const mgnlProps = {
  ...BigCardCarouselBuilder.build(props),
  topTitleColor: magnoliaGetters.getHexColor(topTitleColor?.value),
  subtitleColor: magnoliaGetters.getHexColor(subtitleColor?.value),
};

const mgnlPropsWithBtnColors = {
  ...mgnlProps,
  items: mgnlProps.items?.map(item => ({
    ...item.mode,
    titleColor: magnoliaGetters.getHexColor(item.mode?.titleColor),
    subtitleColor: magnoliaGetters.getHexColor(item.mode?.subtitleColor),
    productId: item.mode?.product ? JSON.parse(item.mode?.product)?.productId : undefined,
  })),
  productsIds: mgnlProps.items?.reduce((acc, item) => {
    if (item.mode?.field === 'product') {
      return [...acc, JSON.parse(item.mode?.product)?.productId];
    }
    return acc;
  }, []),
};
</script>
